import React from "react"
import logoVietrade from '../assets/img/vietrade-official-logo.png'

export function VietradeLogoSmall() {
  return (
    <div className="flex items-center space-x-2">
      <div className="w-6 h-6 bg-white rounded border border-gray-200 p-1 shadow-sm">
        <img
          src={logoVietrade}
          alt="Vietrade"
          className="w-full h-full object-contain"
          onError={(e) => {
            e.currentTarget.src =
              "https://via.placeholder.com/24x24?text=VT"
          }}
        />
      </div>
      <span className="font-semibold text-gray-800 text-sm">VietradeAI</span>
    </div>
  )
}
